<template>
    <div class="admin-home-config">
      <h1>官網首頁設置</h1>
  
      <!-- ================= 首頁輪播圖片管理區 ================= -->
    <h2 class="section-title">首頁輪播圖片管理</h2>
    <div class="carousel-grid">
      <div
        class="carousel-card"
        v-for="(banner, bIndex) in home_carousel_banners"
        :key="banner.id ?? bIndex"
      >
        <!-- 圖片預覽 (網站用) -->
        <div class="image-preview">
          <img
            v-if="banner.image_url"
            :src="banner.image_url"
            alt="Carousel Desktop"
            loading="lazy"
          />
          <div v-else class="no-image">No Image</div>
        </div>
        <label>電腦版圖片 (1920x450)</label>
        <input
          class="my-input"
          v-model="banner.image_url"
          placeholder="https://xxx_desktop.jpg"
        />

        <!-- 圖片預覽 (手機用) -->
        <div class="image-preview">
          <img
            v-if="banner.phone_url"
            :src="banner.phone_url"
            alt="Carousel Mobile"
            loading="lazy"
          />
          <div v-else class="no-image">No Image</div>
        </div>
        <label>手機版圖片 (853x1280)</label>
        <input
         class="my-input"
          v-model="banner.phone_url"
          placeholder="https://xxx_phone.jpg"
        />

        <!-- 輸入標題 ctitle -->
        <label>標題 (ctitle)</label>
        <input
        class="my-input"
          v-model="banner.ctitle"
          placeholder="輸入輪播標題"
        />

        <!-- 輸入描述 description -->
        <label>描述 (description)</label>
        <textarea
          v-model="banner.description"
          placeholder="輸入描述內容"
        ></textarea>

        <!-- 輸入連結 link_url -->
        <label>連結 (link_url)</label>
        <input
        class="my-input"
          v-model="banner.link_url"
          placeholder="/product/100001"
        />

        <!-- 排序 sort_order -->
        <label>排序 (sort_order，越小排越前)</label>
        <input
          type="number"
          v-model.number="banner.sort_order" 
          placeholder="0"
        />

        <!-- 是否啟用 is_active (滑動開關或勾選) -->
        <div class="toggle-active">
          <label>是否啟用</label>
          <label class="switch">
            <input
              type="checkbox"
              v-model="banner.is_active"
              :true-value="1"
              :false-value="0"
            />
            <span class="slider"></span>
          </label>
        </div>

        <!-- 功能按鈕 -->
        <div class="action-buttons">
          <!-- 儲存 (更新 or 新增) -->
          <button @click="saveCarouselBanner(banner, bIndex)">
            {{ banner.id ? '更新' : '新增' }}
          </button>

          <!-- 刪除 -->
          <button
            v-if="banner.id"
            class="delete-btn"
            @click="deleteCarouselBanner(banner, bIndex)"
          >
            刪除
          </button>

          <!-- 取消新項目 -->
          <button
            v-else
            class="delete-btn"
            @click="cancelNewCarouselBanner(bIndex)"
          >
            取消
          </button>
        </div>
      </div>
    </div>
    <button class="add-btn" @click="addCarouselBanner">
      + 新增輪播圖片
    </button>

      <!-- ================= 專業美容師形象管理區 ================= -->
      <div class="endorsement-grid">
        <div
          class="endorsement-card"
          v-for="(item, index) in homeBeauticianEndorsements"
          :key="item.id ?? index"
        >
          <!-- 圖片預覽 (如果有 URL) -->
          <div class="image-preview">
            <img
              v-if="item.image_url"
              :src="item.image_url"
              alt="Beautician Endorsement"
              loading="lazy"
            />
            <div v-else class="no-image">No Image</div>
          </div>
  
          <!-- 輸入圖片 URL -->
          <label>圖片URL 1050x1050</label>
          <input
            v-model="item.image_url"
            placeholder="https://xxx.jpg"
          />
  
          <!-- 是否啟用 is_active (滑動開關或勾選) -->
          <div class="toggle-active">
            <label>是否啟用</label>
            <label class="switch">
              <input
                type="checkbox"
                v-model="item.is_active"
                :true-value="1"
                :false-value="0"
              />
              <span class="slider"></span>
            </label>
          </div>
  
          <!-- 功能按鈕 -->
          <div class="action-buttons">
            <!-- 儲存 (更新 or 新增) -->
            <button @click="saveEndorsement(item, index)">
              {{ item.id ? '更新' : '新增' }}
            </button>
  
            <!-- 刪除 -->
            <button v-if="item.id" class="delete-btn" @click="deleteEndorsement(item, index)">
              刪除
            </button>
            <!-- 如果是尚未存到資料庫(沒有 id)，也可以用「取消」把這筆資料從陣列移除 -->
            <button v-else class="delete-btn" @click="cancelNew(index)">
              取消
            </button>
          </div>
        </div>
      </div>
      <button class="add-btn" @click="addEndorsement" style="margin-top: 1rem">
        + 新增專業美容師
      </button>
  
      <!-- ================= 用戶評價管理區 ================= -->
      <h2 class="section-title">用戶評價管理</h2>
      <div class="testimonial-grid">
        <div
          class="testimonial-card"
          v-for="(titem, tindex) in homeUserTestimonials"
          :key="titem.id ?? tindex"
        >
          <!-- 圖片預覽 (如果有 URL) -->
          <div class="image-preview">
            <img
              v-if="titem.image_url"
              :src="titem.image_url"
              alt="User Testimonial"
              loading="lazy"
            />
            <div v-else class="no-image">No Image</div>
          </div>
  
          <!-- 輸入圖片 URL -->
          <label>圖片URL 800x800</label>
          <input
            v-model="titem.image_url"
            placeholder="https://xxx.jpg"
          />
  
          <!-- 輸入評語 (review) -->
          <label>使用者評價內容</label>
          <textarea
            v-model="titem.review"
            placeholder="輸入使用者評價內容"
          ></textarea>
  
          <!-- 是否啟用 is_active (滑動開關或勾選) -->
          <div class="toggle-active">
            <label>是否啟用</label>
            <label class="switch">
              <input
                type="checkbox"
                v-model="titem.is_active"
                :true-value="1"
                :false-value="0"
              />
              <span class="slider"></span>
            </label>
          </div>
  
          <!-- 功能按鈕 -->
          <div class="action-buttons">
            <!-- 儲存 (更新 or 新增) -->
            <button @click="saveTestimonial(titem, tindex)">
              {{ titem.id ? '更新' : '新增' }}
            </button>
  
            <!-- 刪除 -->
            <button
              v-if="titem.id"
              class="delete-btn"
              @click="deleteTestimonial(titem, tindex)"
            >
              刪除
            </button>
  
            <!-- 取消新項目 -->
            <button v-else class="delete-btn" @click="cancelNewTestimonial(tindex)">
              取消
            </button>
          </div>
        </div>
      </div>
      <button class="add-btn" @click="addTestimonial">+ 新增用戶評價</button>
  
      <!-- ================= 首頁證書管理區 ================= -->
      <h2 class="section-title">首頁證書管理</h2>
      <div class="certificates-grid">
        <div
          class="certificate-card"
          v-for="(citem, cindex) in home_certificates"
          :key="citem.id ?? cindex"
        >
          <!-- 圖片預覽 (如果有 URL) -->
          <div class="image-preview">
            <img
              v-if="citem.image_url"
              :src="citem.image_url"
              alt="Certificate"
              loading="lazy"
            />
            <div v-else class="no-image">No Image</div>
          </div>
  
          <!-- 輸入圖片 URL -->
          <label>圖片URL 390 x 550</label>
          <input
            v-model="citem.image_url"
            placeholder="https://xxx.jpg"
          />
  
          <!-- 證書標題 -->
          <label>證書標題 (title)</label>
          <input
            v-model="citem.title"
            placeholder="輸入證書標題"
          />
  
          <!-- 證書描述 -->
          <label>證書描述 (description)</label>
          <textarea
            v-model="citem.description"
            placeholder="輸入證書描述"
          ></textarea>
  
          <!-- 是否啟用 is_active (滑動開關或勾選) -->
          <div class="toggle-active">
            <label>是否啟用</label>
            <label class="switch">
              <input
                type="checkbox"
                v-model="citem.is_active"
                :true-value="1"
                :false-value="0"
              />
              <span class="slider"></span>
            </label>
          </div>
  
          <!-- 功能按鈕 -->
          <div class="action-buttons">
            <!-- 儲存 (更新 or 新增) -->
            <button @click="saveCertificate(citem, cindex)">
              {{ citem.id ? '更新' : '新增' }}
            </button>
            <!-- 刪除 -->
            <button
              v-if="citem.id"
              class="delete-btn"
              @click="deleteCertificate(citem, cindex)"
            >
              刪除
            </button>
            <!-- 取消新項目 -->
            <button
              v-else
              class="delete-btn"
              @click="cancelNewCertificate(cindex)"
            >
              取消
            </button>
          </div>
        </div>
      </div>
      <button class="add-btn" @click="addCertificate">+ 新增首頁證書</button>
    </div>
  </template>
  
  <script setup>
  import { onBeforeMount, defineOptions, ref, onMounted } from 'vue'
  import axios from 'axios'
  import Swal from 'sweetalert2'
  import { useAdminSysTempStore } from '@/store/adminSysTempStore.js'
  import { useRouter } from 'vue-router'
  
  const router = useRouter()
  const useAdminSysTemp = useAdminSysTempStore()
  
  onBeforeMount(async () => {
    // 檢查是否登入
    await useAdminSysTemp.fetchAdminCheckLogin()
    if (!useAdminSysTemp.isLoggedIn) {
      router.push('/admin/login')
      return
    }
  })
  
  defineOptions({
    name: 'AdminHomeImages'
  })
  
  // =================  首頁輪播圖片 =================
  const home_carousel_banners = ref([])

  // ================= 專業美容師形象 =================
  const homeBeauticianEndorsements = ref([])
  
  // ================= 用戶評價 =================
  const homeUserTestimonials = ref([])
  
  // ================= 首頁證書 =================
  const home_certificates = ref([])
  
  // 載入後端資料
  onMounted(async () => {
    try {
      const resp = await axios.get('/api/admin/loadHomeData')
      console.log(resp.data)
  
      if (resp.data.success) {
        homeBeauticianEndorsements.value = resp.data.homeBeauticianEndorsements || []
        homeUserTestimonials.value = resp.data.homeUserTestimonials || []
        home_certificates.value = resp.data.home_certificates || []
        home_carousel_banners.value = resp.data.home_carousel_banners || []

      } else {
        alert(resp.data.message)
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '載入首頁設置資料失敗',
        timer: 2000
      })
    }
  })

  /* ================== 輪播圖片 (Carousel Banner) 相關方法 ================== */
    const addCarouselBanner = () => {
      home_carousel_banners.value.push({
        id: null,
        image_url: '',
        phone_url: '',
        ctitle: '',
        description: '',
        link_url: '',
        sort_order: 0,
        is_active: 1
      })
    }

    const formErrors = ref({})

    const saveCarouselBanner = async (banner) => {
      try {

        let errorMsg = ''
        formErrors.value = {}

        if (isNaN(banner.sort_order) || banner.sort_order ==""  || banner.sort_order < 0) {
            errorMsg = '請輸入有效的排序 (必須是非負數字)';
            formErrors.value.sort_order = errorMsg
        }

        if (!banner.link_url) {
            errorMsg = '請輸入連結'
            formErrors.value.link_url = errorMsg
        }
        if (!banner.description) {
            errorMsg = '請輸入描述'
            formErrors.value.description = errorMsg
        }
        if (!banner.ctitle) {
            errorMsg = '請輸入標題'
            formErrors.value.ctitle = errorMsg
        }
        if (!banner.phone_url) {
            errorMsg = '請輸入手機版圖片 URL'
            formErrors.value.phone_url = errorMsg
        }

        if (!banner.image_url) {
            errorMsg = '請輸入圖片 URL'
            formErrors.value.image_url = errorMsg
        }

        if (errorMsg) {
            Swal.fire({
                icon: 'error',
                title: '錯誤',
                text: errorMsg,
                timer: 2000
            })
            return
        }


        // 決定新增 or 更新
        const apiPath = banner.id
          ? '/api/admin/updateCarouselBanner'
          : '/api/admin/createCarouselBanner'
          

        const resp = await axios.post(apiPath, {
          id: banner.id,
          image_url: banner.image_url,
          phone_url: banner.phone_url,
          ctitle: banner.ctitle,
          description: banner.description,
          link_url: banner.link_url,
          sort_order: banner.sort_order,
          is_active: banner.is_active
        })

        if (resp.data.success) {
          console.log(resp.data)

          Swal.fire({
            icon: 'success',
            title: '成功',
            text: resp.data.message || (banner.id ? '更新成功' : '新增成功'),
            timer: 1500
          })
          // 如果是新建，後端回傳 newId
          if (!banner.id && resp.data.newId) {
            banner.id = resp.data.newId
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: '錯誤',
            text: resp.data.message || '操作失敗',
            timer: 2000
          })
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '儲存失敗',
          timer: 2000
        })
      }
    }

    const deleteCarouselBanner = async (banner, bIndex) => {
      try {
        const result = await Swal.fire({
          title: '確認刪除?',
          text: '刪除後無法復原',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: '確認刪除',
          cancelButtonText: '取消'
        })
        if (!result.isConfirmed) {
          return
        }

        const resp = await axios.post('/api/admin/deleteCarouselBanner', {
          id: banner.id
        })

        if (resp.data.success) {
          home_carousel_banners.value.splice(bIndex, 1)
          Swal.fire({
            icon: 'success',
            title: '成功',
            text: '刪除成功',
            timer: 1500
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: '錯誤',
            text: resp.data.message || '刪除失敗',
            timer: 2000
          })
        }
      } catch (error) {
        console.error(error)
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '刪除失敗',
          timer: 2000
        })
      }
    }

    const cancelNewCarouselBanner = (bIndex) => {
      home_carousel_banners.value.splice(bIndex, 1)
    }
      
  /* ================== 專業美容師形象相關方法 ================== */
  const addEndorsement = () => {
    homeBeauticianEndorsements.value.push({
      id: null,
      image_url: '',
      is_active: 1
    })
  }
  
  const saveEndorsement = async (item) => {
    try {


      if (!item.image_url) {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '請輸入圖片 URL',
          timer: 2000
        })
        return
      }

      const apiPath = item.id
        ? '/api/admin/updateBeauticianEndorsement'
        : '/api/admin/createBeauticianEndorsement'
  
      const resp = await axios.post(apiPath, {
        id: item.id,
        image_url: item.image_url,
        is_active: item.is_active
      })
  
      if (resp.data.success) {
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: resp.data.message || (item.id ? '更新成功' : '新增成功'),
          timer: 1500
        })
        // 新增的情況，後端回傳 newId
        if (!item.id && resp.data.newId) {
          item.id = resp.data.newId
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '操作失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '儲存失敗',
        timer: 2000
      })
    }
  }
  
  const deleteEndorsement = async (item, index) => {
    try {
      const result = await Swal.fire({
        title: '確認刪除?',
        text: '刪除後無法復原',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確認刪除',
        cancelButtonText: '取消'
      })
  
      if (!result.isConfirmed) {
        return
      }
  
      const resp = await axios.post('/api/admin/deleteBeauticianEndorsement', {
        id: item.id
      })
  
      if (resp.data.success) {
        homeBeauticianEndorsements.value.splice(index, 1)
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: '刪除成功',
          timer: 1500
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '刪除失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '刪除失敗',
        timer: 2000
      })
    }
  }
  
  const cancelNew = (index) => {
    homeBeauticianEndorsements.value.splice(index, 1)
  }
  
  /* ================== 用戶評價 (User Testimonials) 相關方法 ================== */
  const addTestimonial = () => {
    homeUserTestimonials.value.push({
      id: null,
      image_url: '',
      review: '',
      is_active: 1
    })
  }
  
  const saveTestimonial = async (titem) => {
    try {
      if (!titem.image_url) {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '請輸入圖片 URL',
          timer: 2000
        })
        return
      }
      
      const apiPath = titem.id
        ? '/api/admin/updateUserTestimonial'
        : '/api/admin/createUserTestimonial'
  
      const resp = await axios.post(apiPath, {
        id: titem.id,
        image_url: titem.image_url,
        review: titem.review,
        is_active: titem.is_active
      })
  
      if (resp.data.success) {
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: resp.data.message || (titem.id ? '更新成功' : '新增成功'),
          timer: 1500
        })
        if (!titem.id && resp.data.newId) {
          titem.id = resp.data.newId
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '操作失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '儲存失敗',
        timer: 2000
      })
    }
  }
  
  const deleteTestimonial = async (titem, tindex) => {
    try {
      const result = await Swal.fire({
        title: '確認刪除?',
        text: '刪除後無法復原',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確認刪除',
        cancelButtonText: '取消'
      })
  
      if (!result.isConfirmed) {
        return
      }
  
      const resp = await axios.post('/api/admin/deleteUserTestimonial', {
        id: titem.id
      })
  
      if (resp.data.success) {
        homeUserTestimonials.value.splice(tindex, 1)
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: '刪除成功',
          timer: 1500
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '刪除失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '刪除失敗',
        timer: 2000
      })
    }
  }
  
  const cancelNewTestimonial = (tindex) => {
    homeUserTestimonials.value.splice(tindex, 1)
  }
  
  /* ================== 首頁證書 (Home Certificates) 相關方法 ================== */
  const addCertificate = () => {
    home_certificates.value.push({
      id: null,
      image_url: '',
      title: '',
      description: '',
      is_active: 1
    })
  }
  
  const saveCertificate = async (citem) => {
    try {

      if (!citem.image_url) {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '請輸入圖片 URL',
          timer: 2000
        })
        return
      }
      
      // 判斷是「更新」或「新增」
      const apiPath = citem.id
        ? '/api/admin/updateCertificate'
        : '/api/admin/createCertificate'
  
      const resp = await axios.post(apiPath, {
        id: citem.id,
        image_url: citem.image_url,
        title: citem.title,
        description: citem.description,
        is_active: citem.is_active
      })
  
      if (resp.data.success) {
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: resp.data.message || (citem.id ? '更新成功' : '新增成功'),
          timer: 1500
        })
        // 若是新增，後端可回傳 newId
        if (!citem.id && resp.data.newId) {
          citem.id = resp.data.newId
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '操作失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '儲存失敗',
        timer: 2000
      })
    }
  }
  
  const deleteCertificate = async (citem, cindex) => {
    try {
      const result = await Swal.fire({
        title: '確認刪除?',
        text: '刪除後無法復原',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '確認刪除',
        cancelButtonText: '取消'
      })
  
      if (!result.isConfirmed) {
        return
      }
  
      const resp = await axios.post('/api/admin/deleteCertificate', {
        id: citem.id
      })
  
      if (resp.data.success) {
        home_certificates.value.splice(cindex, 1)
        Swal.fire({
          icon: 'success',
          title: '成功',
          text: '刪除成功',
          timer: 1500
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: resp.data.message || '刪除失敗',
          timer: 2000
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: 'error',
        title: '錯誤',
        text: '刪除失敗',
        timer: 2000
      })
    }
  }
  
  const cancelNewCertificate = (cindex) => {
    home_certificates.value.splice(cindex, 1)
  }
  </script>
  
  <style scoped>
  .admin-home-config {
    background-color: #fafafa;
    padding: 1rem;
    border-radius: 6px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }
  
  .section-title {
    margin-top: 2rem;
    margin-bottom: 0.5rem;
  }
  
  .add-btn {
    margin-bottom: 1rem;
    background-color: #4CAF50;
    color: #fff;
    border: none;
    padding: 8px 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  /* ================= 專業美容師形象 ================= */
  .endorsement-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 2rem; /* 與下方區域做間隔 */
  }
  
  .endorsement-card {
    background-color: #fff;
    border-radius: 6px;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  /* ================= 用戶評價 ================= */
  .testimonial-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 2rem; /* 與下方區域做間隔 */
  }
  
  .testimonial-card {
    background-color: #fff;
    border-radius: 6px;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  /* ================= 首頁證書 ================= */
  .certificates-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 2rem;
  }
  
  .certificate-card {
    background-color: #fff;
    border-radius: 6px;
    padding: 1rem;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  /* 圖片預覽區 (三者共用) */
  .image-preview {
    width: 100%;
    height: 140px;
    margin-bottom: 1rem;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .image-preview img {
    max-width: 100%;
    max-height: 100%;
  }
  
  .no-image {
    color: #999;
    font-size: 0.9rem;
  }
  
  /* label 與 input (三者共用) */
  .endorsement-card label,
  .testimonial-card label,
  .certificate-card label {
    display: block;
    margin-top: 8px;
    text-align: left;
    font-size: 0.9rem;
    margin-bottom: 4px;
  }
  
  .endorsement-card input[type="text"],
  .testimonial-card input[type="text"],
  .certificate-card input[type="text"],
  .testimonial-card textarea,
  .certificate-card textarea {
    width: 100%;
    padding: 6px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9rem;
  }
  
  .testimonial-card textarea,
  .certificate-card textarea {
    min-height: 60px;
    resize: vertical;
  }
  
  /* 是否啟用 (三者共用) */
  .toggle-active {
    margin: 8px 0;
    text-align: left;
  }
  
  /* -------------- Toggle Switch 核心樣式 (共用) -------------- */
  .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    margin-left: 8px;
    vertical-align: middle;
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: #ccc;
    transition: .4s;
    border-radius: 34px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 16px; width: 16px;
    left: 3px; bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
  
  input:checked + .slider {
    background-color: #2196F3;
  }
  
  input:checked + .slider:before {
    transform: translateX(18px);
  }
  
  /* 功能按鈕 (三者共用) */
  .action-buttons {
    margin-top: 1rem;
    text-align: center;
  }
  
  .action-buttons button {
    margin: 0 4px;
    padding: 6px 12px;
    font-size: 0.9rem;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #ddd;
    background-color: #eee;
  }
  
  .action-buttons .delete-btn {
    background-color: #f44336;
    color: #fff;
    border: none;
  }
  
  /* 輸入框字體大小 */
  input, textarea {
    font-size: 1.0rem !important;
  }


  .admin-home-config {
  background-color: #fafafa;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.section-title {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.add-btn {
  margin-bottom: 1rem;
  background-color: #4CAF50;
  color: #fff;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  border-radius: 4px;
}

/* ================= 首頁輪播圖片管理 ================= */
.my-input {
  display: inline-block;
  width: 100%;
  padding: 8px 12px;
  font-size: 16px;
  color: #333;
  background-color: #fff;
  border: 1px solid #ccc;  
  border-radius: 4px;      
  box-sizing: border-box;  
  outline: none;           
}

.my-input:focus {
  border-color: #66afe9; 
  box-shadow: 0 0 5px rgba(102, 175, 233, 0.6);
}


.carousel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(500px, 100%), 1fr));
  gap: 16px;
  margin-bottom: 2rem;
}

.carousel-card {
  background-color: #fff;
  border-radius: 6px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/* 圖片預覽區 */
.image-preview {
  width: 100%;
  height: 140px;
  margin-bottom: 1rem;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview img {
  max-width: 100%;
  max-height: 100%;
}

.no-image {
  color: #999;
  font-size: 0.9rem;
}

/* label 與 input */
.carousel-card label {
  display: block;
  margin-top: 8px;
  text-align: left;
  font-size: 0.9rem;
  margin-bottom: 4px;
}

.carousel-card input[type="text"],
.carousel-card input[type="number"],
.carousel-card textarea {
  width: 100%;
  padding: 6px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.9rem;
  margin-bottom: 8px; /* 避免擠在一起 */
  box-sizing: border-box;
}

.carousel-card textarea {
  min-height: 60px;
  resize: vertical;
}

/* 切換開關 */
.toggle-active {
  margin: 8px 0;
  text-align: left;
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  margin-left: 8px;
  vertical-align: middle;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0; 
  left: 0; 
  right: 0; 
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px; 
  width: 16px;
  left: 3px; 
  bottom: 3px;
  background-color: white;
  transition: .4s;
  border-radius: 50%;
}
input:checked + .slider {
  background-color: #2196F3;
}
input:checked + .slider:before {
  transform: translateX(18px);
}

/* 功能按鈕 */
.action-buttons {
  margin-top: 1rem;
  text-align: center;
}
.action-buttons button {
  margin: 0 4px;
  padding: 6px 12px;
  font-size: 0.9rem;
  border-radius: 4px;
  cursor: pointer;
  border: 1px solid #ddd;
  background-color: #eee;
}
.action-buttons .delete-btn {
  background-color: #f44336;
  color: #fff;
  border: none;
}
  </style>
  